import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { Button, Flex, Heading, Tabs, theme } from '@percent/lemonade'
import { useGrantsPermissions } from '@percent/admin-dashboard/app/grants/hooks/useGrantsPermissions'
import { ProgramTab, ProgramTabs, type ProgramHeaderProps } from './ProgramHeader.types'
import styles from './ProgramHeader.module.scss'
import { RecalculateProgramModal } from './recalculateProgramModal/RecalculateProgramModal'
import { EditProgramModal } from './editProgramModal/EditProgramModal'

export function ProgramHeader({ program, activeTab, setActiveTab, onProgramAction }: Readonly<ProgramHeaderProps>) {
  const [isRecalculateProgramModalOpen, setIsRecalculateProgramModalOpen] = useState(false)
  const [isEditProgramModalOpen, setIsEditProgramModalOpen] = useState(false)

  const { t } = useTranslation()
  const [canUpdateProgram] = useGrantsPermissions(['can_update_program'])

  const tabs: ProgramTabs = [
    {
      label: t('grants.programDetails.header.overview'),
      key: ProgramTab.OVERVIEW
    },
    {
      label: t('grants.programDetails.header.stateMachine'),
      key: ProgramTab.STATE_MACHINE
    },
    {
      label: t('grants.programDetails.header.candidates'),
      key: ProgramTab.CANDIDATES
    },
    {
      label: t('grants.programDetails.header.taskTemplates'),
      key: ProgramTab.TASK_TEMPLATES
    }
  ]

  return (
    <>
      <Flex direction="column" className={styles.header} data-testid="program-header">
        <Flex direction="column" justify="flex-start" align="flex-start" className={styles.heading}>
          <Flex align="center" w="100%" gap={theme.sizes.s}>
            <Flex gap={theme.sizes.xs} align="center" w="100%">
              <Heading level="h3" data-testid="candidate-header-title">
                {program.name}
              </Heading>

              {canUpdateProgram && (
                <Flex ml="auto" gap={12}>
                  <Button variant="secondary" size="small" onClick={() => setIsEditProgramModalOpen(true)}>
                    {t('button.edit')}
                  </Button>
                  <Button variant="secondary" size="small" onClick={() => setIsRecalculateProgramModalOpen(true)}>
                    {t('button.recalculate')}
                  </Button>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>

        <Tabs
          items={tabs}
          activeTab={activeTab}
          onChangeTab={newTab => setActiveTab(newTab as ProgramTab)}
          scrollable
        />
      </Flex>
      <EditProgramModal
        open={isEditProgramModalOpen}
        setOpen={setIsEditProgramModalOpen}
        program={program}
        onUpdate={onProgramAction}
      />
      <RecalculateProgramModal
        open={isRecalculateProgramModalOpen}
        setOpen={setIsRecalculateProgramModalOpen}
        programId={program.id}
      />
    </>
  )
}
